import { createContext, useContext } from "react";
import { useAuth } from "./AuthContext";

const FeatureContext = createContext(null);

// Feature to package mapping — nomi devono matchare packages.nome in DB per la reactivation modal
const FEATURE_PACKAGES = {
  // Menu & Ricette
  ricette: "Menu & Ricette",
  menu_vendita: "Menu & Ricette",
  // Acquisti & Fornitori → DB: "Gestione Acquisti"
  fornitori: "Gestione Acquisti",
  prodotti_catalogo: "Gestione Acquisti",
  ordini_fornitori: "Gestione Acquisti",
  fatture_acquisto: "Gestione Acquisti",
  // chiavi legacy (backward compat con abbonamenti esistenti)
  materie_prime: "Menu & Ricette",
  food_beverage: "Gestione Acquisti",
  attrezzature_packaging: "Gestione Acquisti",
  storico_fatture: "Gestione Acquisti",
  // HACCP & Operatività → DB: "HACCP & Controlli"
  controllo_temperature: "HACCP & Controlli",
  piano_pulizie: "HACCP & Controlli",
  tracciabilita_lotti: "HACCP & Controlli",
  bacheca_compiti: "HACCP & Controlli",
  segnalazioni: "HACCP & Controlli",
  calendario: "HACCP & Controlli",
  // Personale → DB: "Gestione Personale"
  turni: "Gestione Personale",
  ferie_permessi: "Gestione Personale",
  presenze: "Gestione Personale",
  schede_personale: "Gestione Personale",
  // Cassa & Contabilità
  prima_nota: "Cassa & Contabilità",
  // Archivio & Documenti
  archivio_documenti: "Archivio & Documenti",
  // Impostazioni extra
  contatti_utili: "Impostazioni & Anagrafica",
  servizi_delivery: "Impostazioni & Anagrafica",
  bot_telegram: "Impostazioni & Anagrafica",
  // Dashboard
  dashboard: "Base",
};

// Aliases: nuovi key sidebar → vecchi key backend (per backward compat con abbonamenti esistenti)
const FEATURE_ALIASES = {
  prodotti_catalogo: ["food_beverage", "materie_prime", "acquisti_fornitori"],
  ordini_fornitori:  ["food_beverage", "attrezzature_packaging", "acquisti_fornitori"],
  fatture_acquisto:  ["storico_fatture", "food_beverage", "acquisti_fatture", "acquisti_fornitori"],
};

export const FeatureProvider = ({ children }) => {
  const { user, isAdmin } = useAuth();
  const sub = user?.subscription || {};
  const isGratuito = sub.gratuito === true;
  const features = sub.features || [];
  const trialUsed = sub.trial_used === true;  // Phase D

  const hasFeature = (featureKey) => {
    if (isGratuito || features.includes("all")) return true;
    if (features.includes(featureKey)) return true;
    // Controlla alias backward-compat (chiavi frontend → chiavi backend legacy)
    const aliases = FEATURE_ALIASES[featureKey] || [];
    return aliases.some(alias => features.includes(alias));
  };

  const getPackageName = (featureKey) => FEATURE_PACKAGES[featureKey] || "Pacchetto";

  return (
    <FeatureContext.Provider value={{ hasFeature, getPackageName, isGratuito, features, trialUsed }}>
      {children}
    </FeatureContext.Provider>
  );
};

export const useFeature = () => {
  const ctx = useContext(FeatureContext);
  if (!ctx) return { hasFeature: () => true, getPackageName: () => "", isGratuito: true, features: ["all"], trialUsed: false };
  return ctx;
};
